export * from './cogoport-adds-linescape-schedules.component';


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/cogoport-adds-linescape-schedules/index.ts